import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Component for protected routes that require authentication
const ProtectedRoute = () => {
  const { currentUser, loading } = useAuth();

  // Show a loading indicator while verifying authentication
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="animate-spin h-8 w-8 border-4 border-blue-500 rounded-full border-t-transparent"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Render child routes if authenticated
  return <Outlet />;
};

export default ProtectedRoute;